import {
    IServiceCNSAccountSummaryDto,
    IServiceDTCCTradeSummaryDto,
    IServiceCNSProjectionDto,
    IServiceReportsStoreGetParams,
    IServiceCNSAccountSummaryGetQuery,
    IServiceDTCCTradeSummaryGetQuery,
    IServiceCNSProjectionGetQuery,
    IServiceReportsStoreGetQuery,
    IServiceOWReportsDto,
    ListResult,
} from '@shared/api';
import { Api } from '../../Api';

export class ReportsStore {
    private static _basePath = '/reports';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${ReportsStore._basePath}`;
        return {
            async getCNSAccountSummary(
                { date }: IServiceReportsStoreGetParams,
                query: IServiceCNSAccountSummaryGetQuery,
            ) {
                const path = `/cns-account-summary/${date}`;
                return await Api.get<IServiceCNSAccountSummaryDto>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getOWPositionsReports({ date }: IServiceReportsStoreGetParams, query: IServiceReportsStoreGetQuery) {
                const path = `/ow-positions/${date}`;
                return await Api.get<ListResult<IServiceOWReportsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getDTCCTradeSummary(
                { date }: IServiceReportsStoreGetParams,
                query: IServiceDTCCTradeSummaryGetQuery,
            ) {
                const path = `/dtcc-trade-summary/${date}`;
                return await Api.get<IServiceDTCCTradeSummaryDto>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCNSProjection({ date }: IServiceReportsStoreGetParams, query: IServiceCNSProjectionGetQuery) {
                const path = `/cns-projection/${date}`;
                return await Api.get<IServiceCNSProjectionDto>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
        };
    }
}
